import { CategoryHeader, ResponsiveBannerImage } from "@repo/components";
import { desktopFallbackBannerImage, mobileFallbackBannerImage } from "@repo/constants/common";
const CategoryTopBanner = ({
  topDesktopBanners,
  topMobileBanners,
  categoryName,
  totalCount
}) => {
  const desktop = topDesktopBanners?.[0] ?? {
    imageURI: desktopFallbackBannerImage,
    width: 1920,
    height: 400
  };
  const mobile = topMobileBanners?.[0] ?? {
    imageURI: mobileFallbackBannerImage,
    width: 430,
    height: 216
  };
  return <div className="relative h-[180px] w-full md:h-[310px]" data-sentry-component="CategoryTopBanner" data-sentry-source-file="CategoryTopBanner.jsx">
      <ResponsiveBannerImage desktopSrc={desktop.imageURI} mobileSrc={mobile.imageURI} desktopWidth={desktop.width} desktopHeight={desktop.height} mobileWidth={mobile.width} mobileHeight={mobile.height} alt={categoryName} className="size-full object-cover" data-sentry-element="ResponsiveBannerImage" data-sentry-source-file="CategoryTopBanner.jsx" />
      <CategoryHeader categoryName={categoryName} totalCount={totalCount} data-sentry-element="CategoryHeader" data-sentry-source-file="CategoryTopBanner.jsx" />
    </div>;
};
export default CategoryTopBanner;